import AFC from "entity/Indicador/AFC";
import ARSUB from "entity/Indicador/ARSUB";
import IPSP from "entity/Indicador/IPSP";
import ADO from "entity/Indicador/ADO";
import TipoIndicador from "..";
import ADF from "entity/Indicador/ADF"
import DCor from "entity/Indicador/DCor"
import Torr from "entity/Indicador/Torr"

export default class PreparoSolo extends TipoIndicador {
    static get abbrev() {
        return 'PreparoSolo';
    }

    static get fullName() {
        return "Preparo de Solo";
    }

    static get field() {
        return "preparoSolo";
    }

    static get indicadores() {
        return [AFC, ADF, ARSUB, IPSP, ADO, DCor, Torr];
    }
}
